import type { FaireProductEntity } from "../../entity_types/product";

export const p_5j4tzzqncc: FaireProductEntity = {
  token: "p_5j4tzzqncc",
  type: "product",
  name: "Garden Bloom",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/8ced3b336a1b712f8b18e5adb8bc256847a0481aff257e0ca10e871f01628f5a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c5beeb9d4df286b76ba0adcffe85b8780559eefcfe70c5d56f18b004e61346d.jpeg",
    "https://cdn.faire.com/fastly/c7b1f2433f536c05d66ba1d4fa2edc49f14dfc7796c4de806462d8317e71dc7d.jpeg",
    "https://cdn.faire.com/fastly/4ca5df42f66399af0f9ad901a7388f230012ff40d72420fccc1d5fc59d223971.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable \n",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:58.574Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
